export const ENTITY_TYPES = {
    LINK: 'LINK',
    SUBSCRIPT: 'SUBSCRIPT',
    SUPERSCRIPT: 'SUPERSCRIPT',
    IMAGE: 'IMAGE',
    HORIZONTAL_RULE: 'HORIZONTAL_RULE'
};
